import { PAYMENTS_MAP, PAYMENTS_METHODS, ResponseMethods } from "../const";
import {
  ErrorType,
  FailureResponseType,
  FailureType,
  SuccessResponseType,
  SuccessType,
} from "../components/payment-processors/types";
import { MethodSetupResponse } from "../types";

export const handleSuccessResultObject = (
  activePaymentMethod: ResponseMethods = PAYMENTS_METHODS.CREDIT_CARD,
  responseData?: MethodSetupResponse
): SuccessResponseType => {
  const paymentMethod = PAYMENTS_MAP[activePaymentMethod];

  return {
    type: `${paymentMethod}_success` as SuccessType,
    [`${paymentMethod}SuccessResponse`]: responseData,
  };
};

export const handleFailureResultObject = (
  activePaymentMethod: ResponseMethods = PAYMENTS_METHODS.CREDIT_CARD,
  responseData?: ErrorType
): FailureResponseType => {
  const paymentMethod = PAYMENTS_MAP[activePaymentMethod];
  return {
    type: `${paymentMethod}_failure` as FailureType,
    [`${paymentMethod}FailureResponse`]: responseData,
  };
};
